<template>
  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
    <div class="datatables">
      <div class="block block-mode-hidden">
        <div v-if="tableLoader && showLoader" class="overlay"></div>
        <hash-loader v-if="tableLoader && showLoader" class="hash-icon table-hash-icon" color="#9eb89f" loading="loading" size="40" sizeUnit="px"></hash-loader>
        <div class="block-header bg-city-light">
          <h3 class="block-title text-white">
            <i class="fa fa-object-group"></i> Plant batch ({{ Object.keys(batches).length }})
            <span class="hash-loader" v-if="showLoader && !tableLoader">
              <hash-loader class="hash-icon" color="#fff" loading="loading" size="20" sizeUnit="px"></hash-loader>
            </span>
          </h3>
          <div class="block-options">
            <button type="button" class="btn-block-option text-white" @click.prevent="showAddPlantBatchModal()">
              <i v-bind:disabled="showLoader" class="si si-plus"></i> Add New
            </button>
            <button @click="tableLoader = !tableLoader" v-bind:disabled="showLoader" type="button" class="btn-block-option text-white" data-toggle="block-option" data-action="content_toggle"></button>
          </div>
        </div>
        <div class="block-content block-content-full">
          <table id="plant-batch-table" class="table table-bordered table-striped table-vcenter js-dataTable-full table-sm">
            <thead>
              <tr>
                <th class="text-center">ID</th>
                <th>Name</th>
                <th>Strain</th>
              </tr>
            </thead>
            <tbody>{{ getPlantBatchEntries }}
              <tr v-for="(batch, index) in batches" :key="index">
                <td class="text-center font-size-sm">{{ batch.Id }}</td>
                <td class="font-w600 font-size-sm text-break-large"> {{ batch.Name }}</td>
                <td class="font-w600 font-size-sm text-break-large"> {{ batch.StrainName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <AddPlantBatch
      @showSuccessMsg="displaySuccessMsg"
        @loadPlantBatch="getAndParsePlantBatches"
    ></AddPlantBatch>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import AddPlantBatch from '@/components/modals/AddPlantBatch';
import $ from 'jquery';
import * as select2 from 'select2/dist/js/select2.full.js';
import 'select2/dist/css/select2.min.css';
Vue.use(VueSpinners);

export default {
  name: 'PlantBatch',
  data() {
    return {
      batches: [],
      showLoader: false,
      tableLoader: false,
      isTableEnabled: false
    };
  },
  mounted() {
    $('.select2-dropdown').each(function(){
      $(this).select2({
        dropdownParent: $(this).parent(),
        placeholder: $(this).attr('placeholder')
      });
    });

    this.getAndParsePlantBatches(false);
  },
  components: {
    AddPlantBatch,
    HashLoader
  },
  computed: {
    getPlantBatchEntries() {
      if (this.$store.state.library.plantBatches.length) {
        return this.enableDataTable(this.$store.state.library.plantBatches);
      }
    }
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['getAllPlantBatches']),
    ...mapGetters('library', ['getPlantBatches']),
    async getAndParsePlantBatches(force) {
      let vm = this;
      if (force || vm.getPlantBatches().length === 0) {
        vm.showLoader = true;
        await vm.getAllPlantBatches();
      }
      if (vm.getPlantBatches().length === 0) {
        vm.enableDataTable([]);
      }
    },
    enableDataTable(data) {
      let vm = this, table;
      vm.showLoader = true;
      if (vm.isTableEnabled) {
        table = jQuery('#plant-batch-table').DataTable();
        table.destroy();
      }
      vm.batches = data;
      vm.prepareDataTable('#plant-batch-table');
      vm.isTableEnabled = true;
      vm.showLoader = false;
    },
    beforeDestroy() {
      this.clear();
    },
    displaySuccessMsg(message) {
      this.success(message);
      this.triggerMessageModal('#alert_modal');
    },
    showAddPlantBatchModal() {
      jQuery('#add_plant_batch').modal('show');
    }
  }
};
</script>
<style>
.select2-selection.select2-selection--single {
  height: calc(2.25rem + 2px) !important;
  font-size: 1rem !important;
  background: #f5f5f5 !important;
  border-radius: 5px;
  color: #575757;
  font-weight: 400;
  width: 100%!important;
  border: transparent !important;
  box-shadow: none !important;
}
.select2-container--default
.select2-selection--single
.select2-selection__rendered {
  line-height: 38px !important;
}
.select2-container--default.select2-container--focus
.select2-selection--single {
  box-shadow: none !important;
  outline: 0;
}
</style>



// WEBPACK FOOTER //
// source/components/boxes/PlantBatch.vue